import { InputLabel, FormHelperText, FormControl, Select as MUISelect, MenuItem } from '@mui/material';

const Select = (props) => {
  const {
    inputLabel = '',
    id,
    helperText,
    options,
    width = '100%',
    variant = 'outlined',
    size = 'medium',
    disabled = false,
    error = false,
    multiple = false,
    required = false,
    children,
    optionStyle = null,
    renderOption,
    ...other
  } = props;
  return (
    <FormControl
      variant={variant}
      size={size}
      disabled={disabled}
      error={error}
      required={required}
      sx={{ width: width }}
    >
      {inputLabel && <InputLabel id={`${id}-label`}>{inputLabel}</InputLabel>}
      <MUISelect
        labelId={`${id}-label`}
        id={id}
        label={inputLabel && inputLabel}
        {...other}
        multiple={multiple}
        inputProps={{ 'data-testid': 'select' }}
      >
        {options &&
          options.map((option, index) => {
            const { value, text, disabled: optionDisabled } = option;

            return (
              <MenuItem
                className={`${optionStyle ?? ''}`}
                key={`${text}-${index}`}
                value={value}
                disabled={optionDisabled}
                data-testid="select-option"
              >
                {renderOption ? renderOption(option) : text}
              </MenuItem>
            );
          })}
        {children}
      </MUISelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default Select;
